var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "player" },
    [
      _c("OSDHeader", {
        attrs: {
          "is-show-osd": _vm.isOSDActive,
          "is-back-active": _vm.getIsBackButtonActive
        },
        on: {
          hide: function() {
            return (_vm.isOSDActive = false)
          }
        }
      }),
      _vm._v(" "),
      _vm.isImage ? _c("ViewerImage", { attrs: { src: _vm.src } }) : _vm._e(),
      _vm._v(" "),
      _vm.isVideo
        ? _c("VideoPlayer", {
            ref: "videoPlayer",
            attrs: {
              src: _vm.src,
              "seek-to": _vm.seekTo,
              title: _vm.title,
              description: _vm.description,
              value: _vm.currentPosition,
              status: _vm.videoStatus,
              autoplay: _vm.autoplay,
              loop: _vm.loop,
              controls: _vm.controls,
              "is-osd-visible": _vm.isOSDActive
            },
            on: {
              status: _vm.handleVideoStatus,
              input: _vm.updatePlayPosition,
              setVideo: _vm.assignVideoObject,
              ended: _vm.handleVideoEnded
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isWebsite
        ? _c("WebViewer", {
            attrs: { src: _vm.src, "scroll-position": _vm.scrollPosition }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isUnknownType
        ? _c("div", [
            _c("table", [
              _vm._m(0),
              _vm._v(" "),
              _c("tr", [
                _c("td", [_vm._v("type")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.type))]),
                _vm._v(" "),
                _c("td", [_vm._v("VIDEO, IMAGE, WEBSITE")])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", [_vm._v("src")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.src))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", [_vm._v("title")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.title))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", [_vm._v("description")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.description))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", [_vm._v("seekTo")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.seekTo))])
              ])
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", [_vm._v("Key")]),
      _vm._v(" "),
      _c("th", [_vm._v("Value")]),
      _vm._v(" "),
      _c("th", [_vm._v("Allowed values")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f808271", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f808271","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/MediaPlayer.vue
// module id = null
// module chunks = 